import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackInternalEvent, trackSessionOnce } from "@/lib/internal-analytics";

export const InternalAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/measurement") return;
    trackSessionOnce();
    void trackInternalEvent("page_view");
  }, [location.pathname, location.search]);

  return null;
};